export default function LoadingSpinner({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center py-16 ${className}`}>
      <div className="w-8 h-8 border-2 border-grove-300 border-t-forest-700 rounded-full animate-spin" />
    </div>
  );
}
